import * as React from 'react';
import styled from 'styled-components';
import { Text, Spacer } from '../parts';
import { Footer } from './parts/Footer';

export const Press: React.FC = () => {
	return (
		<PageBody>
			<Container>
				<Spacer size={60} />
				<Text weight="black" size={50} center>
					Press & Media
				</Text>
				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={20}>
						About Live Rewards
					</Text>
					<Spacer size={15} />
					<Text color="#3d3d3d" size={16}>
						Live Rewards is the exclusive discount membership program that saves you money wherever you shop. With partnerships across thousands of brands and retailers, we provide
						our members with exclusive discounts, local deal alerts, and nationwide availability.
					</Text>
				</ContentSection>

				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={20}>
						Recent News
					</Text>
					<Spacer size={15} />
					<NewsItem>
						<Text weight="bold" size={18}>
							Live Rewards Expands Partnership Network
						</Text>
						<Spacer size={10} />
						<Text color="#3d3d3d" size={14}>
							Live Rewards continues to grow its network of retail partners, bringing exclusive discounts to members nationwide.
						</Text>
					</NewsItem>
					<Spacer size={30} />
					<NewsItem>
						<Text weight="bold" size={18}>
							New Mobile App Features Released
						</Text>
						<Spacer size={10} />
						<Text color="#3d3d3d" size={14}>
							Enhanced deal discovery and personalized recommendations now available in the latest app update.
						</Text>
					</NewsItem>
					<Spacer size={30} />
					<NewsItem>
						<Text weight="bold" size={18}>
							Live Rewards Reaches 100,000 Active Members
						</Text>
						<Spacer size={10} />
						<Text color="#3d3d3d" size={14}>
							Milestone achievement reflects growing consumer interest in exclusive discount memberships.
						</Text>
					</NewsItem>
				</ContentSection>

				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={20}>
						Media Kit
					</Text>
					<Spacer size={15} />
					<Text color="#3d3d3d" size={16}>
						For press inquiries, media kits, and interview requests, please contact:
						<br />
						<br />
						<strong>Press Contact:</strong>
						<br />
						Email: press@liverewardsgo.com
						<br />
						Phone: 1-800-REWARDS
					</Text>
				</ContentSection>

				<Spacer size={100} />
			</Container>
			<Footer />
		</PageBody>
	);
};

const PageBody = styled.div``;

const Container = styled.div`
	max-width: 1200px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 0px 20px;

	@media only screen and (max-width: 1200px) {
		padding: 0px 20px;
	}
`;

const ContentSection = styled.div`
	max-width: 800px;
	width: 100%;
`;

const NewsItem = styled.div`
	padding: 20px;
	border-left: 4px solid #165a63;
	background-color: #f5f5f5;
	border-radius: 4px;
`;
